import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faInstagram} from '@fortawesome/free-brands-svg-icons'
const InstagramIcon = () => {
  return (
    <FontAwesomeIcon icon={faInstagram}/>
  )
}

export default InstagramIcon